// Generate unique ID
export const uid = () => Math.random().toString(36).substr(2, 9);

// Format number as European currency string (comma as decimal separator)
export const fmtEur = (v) => Number(v).toFixed(2).replace('.', ',');
